"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useDrawerFooter_unstable", {
    enumerable: true,
    get: function() {
        return useDrawerFooter_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactutilities = require("@fluentui/react-utilities");
const useDrawerFooter_unstable = (props, ref)=>{
    return {
        components: {
            root: 'footer'
        },
        root: _reactutilities.slot.always((0, _reactutilities.getIntrinsicElementProps)('footer', {
            ref,
            ...props
        }), {
            elementType: 'footer'
        })
    };
};
